import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { JwtHelper } from 'angular2-jwt';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from '@angular/material';
import { TranslateModule, TranslateLoader, TranslateStaticLoader } from 'ng2-translate';

import { AppComponent } from './app.component';

import { routing, appRoutingProviders } from './app.routing';
import { LoginModule, AuthModule, AdminModule } from './index';
import { LoginDomainService } from './modules/domain/services/login/login.domain.service';
import { ConfigService } from './utils/config-service';
import { AuthInterceptor } from './utils/auth.interceptor';
import { TokenFactory } from './utils/token-factory';
import 'hammerjs';
export function translateFactory(http: Http) {
  return new TranslateStaticLoader(http, './assets/i18n', '.json');
}
export function configServiceFactory(configService: ConfigService): Function {
  return () => configService.load();
}
@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory: translateFactory,
      deps: [Http]
    }),
    BrowserAnimationsModule,
    MaterialModule,
    LoginModule,
    AuthModule,
    AdminModule,
    routing
  ],
  exports: [TranslateModule],
  declarations: [
    AppComponent,
  ],
  providers: [appRoutingProviders,
    JwtHelper,
    TokenFactory,
    LoginDomainService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: configServiceFactory,
      deps: [ConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts